import styled from 'styled-components'
import { StyledPanelWrapper } from 'styles/panelStyles.css'
import { useTools } from '../useTools'
import SettingsSearchForm from './SettingsSearchForm'
import CardWrapper from 'components/wrappers/CardWrapper'

import Tooltip from 'share-ui/components/Tooltip/Tooltip'
import { StyledSection } from 'pages/Subnets/panels/ApiPanel/ApiPanel'
import {
    StyledHeaderGroup,
    StyledSectionDescription,
    StyledSectionTitle,
} from 'pages/Home/homeStyle.css'
import { ButtonPrimary } from 'components/Button/Button'

const Settings = ({
    handleSendMessage,
}: {
    handleSendMessage: (
        text: string,
        tools: string[],
        date: string,
        model: string,
        responseType: string,
    ) => void
}) => {
    const { tools } = useTools()

    const toolOptions = tools.map(tool => {
        return { value: tool.name, label: tool.label }
    })

    return (
        <StyledPanelWrapper>
            <StyledSection>
                <StyledHeaderGroup>
                    <div>
                        <StyledSectionTitle>Tools</StyledSectionTitle>

                        <StyledSectionDescription>
                            You can use various tools to enhance your experience.
                        </StyledSectionDescription>
                    </div>
                </StyledHeaderGroup>

                <CardWrapper>
                    <StyledToolsContainer>
                        {tools.map(tool => {
                            return (
                                <Tooltip content={tool.label} key={tool.label}>
                                    <StyledLogo src={tool.icon} alt='' />
                                </Tooltip>
                            )
                        })}
                    </StyledToolsContainer>
                </CardWrapper>
            </StyledSection>

            <StyledSection>
                <StyledHeaderGroup>
                    <div>
                        <StyledSectionTitle>Customize parameters</StyledSectionTitle>

                        <StyledSectionDescription>
                            Here you can customize your feed by adding new search parameters or
                            changing the existing ones.
                        </StyledSectionDescription>
                    </div>

                    <div>
                        <ButtonPrimary>Add new parameter</ButtonPrimary>
                    </div>
                </StyledHeaderGroup>

                <StyledRoot>
                    <SettingsSearchForm
                        handleSendMessage={handleSendMessage}
                        toolOptions={toolOptions}
                        title='Gaming news'
                    />
                    <SettingsSearchForm
                        handleSendMessage={handleSendMessage}
                        toolOptions={toolOptions}
                        title='Olympics 2024'
                    />
                    <SettingsSearchForm
                        handleSendMessage={handleSendMessage}
                        toolOptions={toolOptions}
                        title='Recent news'
                    />
                </StyledRoot>
            </StyledSection>
        </StyledPanelWrapper>
    )
}

export default Settings

const StyledRoot = styled.div`
    width: 100%;

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    align-items: start;
`

const StyledLogo = styled.img`
    width: 24px;
    height: 24px;
    object-fit: cover;
    border-radius: 8px;
`
const StyledToolsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`
